import React from 'react';

export function SystemMenuSection({
  setSystemSubmenuOpen,
  systemActiveTab,
  setSystemActiveTab,
  activeEvent,
  onEventChange,
  effectSettings,
  handleEffectToggle
}) {
  return (
              <div className="system-settings-panel">
                {/* Liquid Glow Background Effects */}
                <div className="system-glow-orb system-glow-orb-1"></div>
                <div className="system-glow-orb system-glow-orb-2"></div>
                <div className="system-glow-orb system-glow-orb-3"></div>
                
                {/* Header mit Zurück-Button */}
                <div className="system-panel-header">
                  <button 
                    className="system-back-btn"
                    onClick={() => setSystemSubmenuOpen(false)}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M15 18l-6-6 6-6" />
                    </svg>
                    Zurück
                  </button>
                  <h2 className="system-panel-title">System-Einstellungen</h2>
                </div>

                {/* Tabs */}
                <div className="system-tabs-full">
                  <button 
                    className={`system-tab-full ${systemActiveTab === 'events' ? 'active' : ''}`}
                    onClick={() => setSystemActiveTab('events')}
                  >
                    <span className="tab-icon">✨</span>
                    <span>Events</span>
                  </button>
                  <button 
                    className={`system-tab-full ${systemActiveTab === 'header' ? 'active' : ''}`}
                    onClick={() => setSystemActiveTab('header')}
                  >
                    <span className="tab-icon">🎨</span>
                    <span>Header</span>
                  </button>
                  <button 
                    className={`system-tab-full ${systemActiveTab === 'schedule' ? 'active' : ''}`}
                    onClick={() => setSystemActiveTab('schedule')}
                  >
                    <span className="tab-icon">📅</span>
                    <span>Zeitplan</span>
                  </button>
                </div>
                
                {/* Content Area */}
                <div className="system-content-area">
                  {/* Events Tab */}
                  {systemActiveTab === 'events' && (
                    <div className="system-content">
                      {/* Aktives Event Neon-Anzeige mit Zeitraum */}
                      <div className="active-event-display">
                        <div className="active-event-glow"></div>
                        <div className="active-event-content">
                          <span className="active-event-label">AKTIV</span>
                          <div className="active-event-info">
                            <span className="active-event-icon">
                              {activeEvent === 'none' && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                  <circle cx="12" cy="12" r="10"/>
                                  <path d="M12 6v6l4 2"/>
                                </svg>
                              )}
                              {activeEvent === 'winter' && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                  <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"/>
                                  <circle cx="12" cy="12" r="3"/>
                                </svg>
                              )}
                              {activeEvent === 'christmas' && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                  <path d="M12 2L8 8h2l-3 6h2l-4 8h14l-4-8h2l-3-6h2L12 2z"/>
                                  <rect x="10" y="20" width="4" height="2"/>
                                </svg>
                              )}
                              {activeEvent === 'silvester' && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                  <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                                  <circle cx="12" cy="12" r="4"/>
                                </svg>
                              )}
                              {activeEvent === 'newyear' && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                  <path d="M8 22h8M12 11v11M17 3l-5 8-5-8"/>
                                  <path d="M7 3h10"/>
                                </svg>
                              )}
                            </span>
                            <div className="active-event-text">
                              <span className="active-event-name">
                                {activeEvent === 'none' && 'Standard'}
                                {activeEvent === 'winter' && 'Winter'}
                                {activeEvent === 'christmas' && 'Weihnachten'}
                                {activeEvent === 'silvester' && 'Silvester'}
                                {activeEvent === 'newyear' && 'Neujahr'}
                              </span>
                              <span className="active-event-period">
                                {activeEvent === 'none' && (() => {
                                  // Berechne bis wann Standard aktiv ist (bis zum nächsten Event)
                                  const now = new Date();
                                  const year = now.getFullYear();
                                  const events = [
                                    { name: 'Weihnachten', start: new Date(year, 11, 20) },
                                    { name: 'Winter', start: new Date(year, 11, 1) },
                                  ];
                                  // Finde das nächste Event
                                  const upcoming = events.filter(e => e.start > now).sort((a, b) => a.start - b.start);
                                  if (upcoming.length > 0) {
                                    const next = upcoming[0];
                                    return `aktiv bis ${next.start.getDate()}. ${['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'][next.start.getMonth()]}`;
                                  }
                                  return 'Ganzjährig';
                                })()}
                                {activeEvent === 'winter' && 'aktiv 01. Dez – 28. Feb'}
                                {activeEvent === 'christmas' && 'aktiv 20. Dez – 26. Dez'}
                                {activeEvent === 'silvester' && 'aktiv 27. Dez – 31. Dez'}
                                {activeEvent === 'newyear' && 'aktiv 01. Jan – 06. Jan'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Nächstes Event Info */}
                      {(() => {
                        const now = new Date();
                        const year = now.getFullYear();
                        const allEvents = [
                          { key: 'winter', name: 'Winter', start: new Date(year, 11, 1), end: new Date(year + 1, 1, 28) },
                          { key: 'christmas', name: 'Weihnachten', start: new Date(year, 11, 20), end: new Date(year, 11, 26) },
                          { key: 'silvester', name: 'Silvester', start: new Date(year, 11, 27), end: new Date(year, 11, 31) },
                          { key: 'newyear', name: 'Neujahr', start: new Date(year + 1, 0, 1), end: new Date(year + 1, 0, 6) },
                        ];
                        const upcoming = allEvents.filter(e => e.key !== activeEvent && e.start > now).sort((a, b) => a.start - b.start);
                        if (upcoming.length > 0) {
                          const next = upcoming[0];
                          const months = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
                          return (
                            <div className="next-event-hint">
                              Nächstes Event: <strong>{next.name}</strong> · {next.start.getDate()}. {months[next.start.getMonth()]} – {next.end.getDate()}. {months[next.end.getMonth()]}
                            </div>
                          );
                        }
                        return null;
                      })()}
                      
                      <div className="system-card">
                        <div className="system-card-header">
                          <svg className="system-card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4"/>
                            <circle cx="12" cy="12" r="5"/>
                          </svg>
                          <span className="system-card-title">Effekte Ein/Aus</span>
                        </div>
                        <div className="toggle-grid">
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">❄️</span>
                              <span>Schnee im Header</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.headerSnow} 
                              onChange={(e) => handleEffectToggle('headerSnow', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">❄️</span>
                              <span>Schnee in Cards</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.cardSnow} 
                              onChange={(e) => handleEffectToggle('cardSnow', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🫧</span>
                              <span>Bubbles in Cards</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.cardBubbles} 
                              onChange={(e) => handleEffectToggle('cardBubbles', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🫧</span>
                              <span>Bubbles im Menü</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.menuBubbles} 
                              onChange={(e) => handleEffectToggle('menuBubbles', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">⛄</span>
                              <span>Figuren im Menü</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.menuFigures} 
                              onChange={(e) => handleEffectToggle('menuFigures', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🎆</span>
                              <span>Feuerwerk</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.menuFireworks} 
                              onChange={(e) => handleEffectToggle('menuFireworks', e.target.checked)} 
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Header Tab */}
                  {systemActiveTab === 'header' && (
                    <div className="system-content">
                      <div className="system-card">
                        <div className="system-card-header">
                          <span className="system-card-icon">📊</span>
                          <span className="system-card-title">Header Anzeige</span>
                        </div>
                        <div className="toggle-grid">
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🕐</span>
                              <span>Uhrzeit anzeigen</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.headerClock} 
                              onChange={(e) => handleEffectToggle('headerClock', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🌡️</span>
                              <span>Wetter anzeigen</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.headerWeather} 
                              onChange={(e) => handleEffectToggle('headerWeather', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">📅</span>
                              <span>Datum anzeigen</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.headerDate} 
                              onChange={(e) => handleEffectToggle('headerDate', e.target.checked)} 
                            />
                          </label>
                          <label className="toggle-card">
                            <div className="toggle-card-info">
                              <span className="toggle-emoji">🌊</span>
                              <span>Wellen-Animation</span>
                            </div>
                            <input 
                              type="checkbox" 
                              checked={effectSettings.headerWaves} 
                              onChange={(e) => handleEffectToggle('headerWaves', e.target.checked)} 
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Schedule Tab */}
                  {systemActiveTab === 'schedule' && (
                    <div className="system-content">
                      <div className="system-card">
                        <div className="system-card-header">
                          <svg className="system-card-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <circle cx="12" cy="12" r="10"/>
                            <path d="M12 6v6l4 2"/>
                          </svg>
                          <span className="system-card-title">Event wählen</span>
                        </div>
                        <div className="event-grid-2col">
                          {/* Standard */}
                          <button
                            className={`event-card-btn ${activeEvent === 'none' ? 'active' : ''}`}
                            onClick={() => onEventChange('none')}
                          >
                            <div className="event-card-icon">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <circle cx="12" cy="12" r="8"/>
                                <path d="M12 8v4l2.5 1.5"/>
                              </svg>
                            </div>
                            <div className="event-card-text">
                              <span className="event-card-name">Standard</span>
                              <span className="event-card-period">Ganzjährig</span>
                            </div>
                          </button>
                          
                          {/* Winter */}
                          <button
                            className={`event-card-btn ${activeEvent === 'winter' ? 'active' : ''}`}
                            onClick={() => onEventChange('winter')}
                          >
                            <div className="event-card-icon">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M12 2v20"/>
                                <path d="M2 12h20"/>
                                <path d="M4.93 4.93l14.14 14.14"/>
                                <path d="M19.07 4.93L4.93 19.07"/>
                                <circle cx="12" cy="12" r="2" fill="currentColor"/>
                              </svg>
                            </div>
                            <div className="event-card-text">
                              <span className="event-card-name">Winter</span>
                              <span className="event-card-period">01. Dez – 28. Feb</span>
                            </div>
                          </button>
                          
                          {/* Weihnachten */}
                          <button
                            className={`event-card-btn ${activeEvent === 'christmas' ? 'active' : ''}`}
                            onClick={() => onEventChange('christmas')}
                          >
                            <div className="event-card-icon">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M12 2L8 8h2l-3 6h2l-4 8h14l-4-8h2l-3-6h2L12 2z"/>
                                <rect x="10" y="20" width="4" height="2" rx="0.5"/>
                              </svg>
                            </div>
                            <div className="event-card-text">
                              <span className="event-card-name">Weihnachten</span>
                              <span className="event-card-period">20. Dez – 26. Dez</span>
                            </div>
                          </button>
                          
                          {/* Silvester */}
                          <button
                            className={`event-card-btn ${activeEvent === 'silvester' ? 'active' : ''}`}
                            onClick={() => onEventChange('silvester')}
                          >
                            <div className="event-card-icon">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M12 2v3"/>
                                <path d="M12 19v3"/>
                                <path d="M4.93 4.93l2.12 2.12"/>
                                <path d="M16.95 16.95l2.12 2.12"/>
                                <path d="M2 12h3"/>
                                <path d="M19 12h3"/>
                                <path d="M4.93 19.07l2.12-2.12"/>
                                <path d="M16.95 7.05l2.12-2.12"/>
                                <circle cx="12" cy="12" r="5"/>
                                <circle cx="12" cy="12" r="2" fill="currentColor"/>
                              </svg>
                            </div>
                            <div className="event-card-text">
                              <span className="event-card-name">Silvester</span>
                              <span className="event-card-period">27. Dez – 31. Dez</span>
                            </div>
                          </button>
                          
                          {/* Neujahr */}
                          <button
                            className={`event-card-btn ${activeEvent === 'newyear' ? 'active' : ''}`}
                            onClick={() => onEventChange('newyear')}
                          >
                            <div className="event-card-icon">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                <path d="M8 21h8"/>
                                <path d="M12 11v10"/>
                                <path d="M17 4l-5 7-5-7"/>
                                <path d="M7 4h10"/>
                                <circle cx="7" cy="4" r="1" fill="currentColor"/>
                                <circle cx="17" cy="4" r="1" fill="currentColor"/>
                              </svg>
                            </div>
                            <div className="event-card-text">
                              <span className="event-card-name">Neujahr</span>
                              <span className="event-card-period">01. Jan – 06. Jan</span>
                            </div>
                          </button>
                        </div>
                      </div>
                      
                      <div className="system-card">
                        <div className="system-card-header">
                          <span className="system-card-icon">⚙️</span>
                          <span className="system-card-title">Manuelle Steuerung</span>
                        </div>
                        <label className="toggle-card solo">
                          <div className="toggle-card-info">
                            <span className="toggle-emoji">🔄</span>
                            <span>Auto-Events aktivieren</span>
                          </div>
                          <input 
                            type="checkbox" 
                            checked={true} 
                            onChange={() => {}} 
                          />
                        </label>
                        <p className="system-card-hint">
                          Wenn deaktiviert, wird das manuell gewählte Event verwendet.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
  );
}
